module.exports = __webpack_public_path__ + "static/best-meets-requirements-winter-2022-69e8226d65c8155ac571ca1862f88620.svg";